import api from '../../services/api';

/*
 * Balances and kardex: the two faces of the same ledger.
 *
 *   balances (`inventories/stock/`)      how much there is NOW
 *   kardex   (`inventories/movements/`)  where that number came from
 *
 * The server applies the scope — an operator sees what is in its warehouses, a
 * client sees its own wherever it is — so nothing here filters for security.
 */

/**
 * @param {object} params - `warehouse, company, product, state, lot, search,
 *   include_zero, group_by ('sku'|'sku_lot'), page, page_size`. With `group_by`
 *   the rows carry `available, reserved, total`; without it, one row per
 *   location, lot and state. `totals` always covers the whole filter.
 */
export const getStockRequest = async (params) => {
  return await api.get('inventories/stock/', { params });
};

/**
 * @param {object} params - The filters above, plus `movement_type, reference,
 *   date_from, date_to`.
 */
export const getStockMovementsRequest = async (params) => {
  return await api.get('inventories/movements/', { params });
};

/**
 * Moves stock between two locations of the same warehouse. It lands in the
 * kardex as two movements, one out and one in, and the answer carries both.
 *
 * @param {{product_id: number, from_slot_id: number, to_slot_id: number,
 *   quantity: string|number, lot?: string, notes?: string}} payload
 */
export const transferStockRequest = async (payload) => {
  return await api.post('inventories/movements/transfer/', payload);
};

/**
 * Adds or removes units by hand, with a reason. One movement of type
 * `adjustment` in the kardex; the server refuses to leave a balance negative.
 *
 * @param {{product_id: number, slot_id?: number, warehouse_id?: number, lot?: string,
 *   state: string, qty_delta: string, notes: string}} payload
 */
export const adjustStockRequest = async (payload) => {
  return await api.post('inventories/movements/adjust/', payload);
};
